(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return; // guard

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mql = window.matchMedia('(max-width: 990px)');
      this._onMqlChange = this.setHeaderHeight.bind(this);
      this.mql.addEventListener('change', this._onMqlChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mql && this._onMqlChange) {
        this.mql.removeEventListener('change', this._onMqlChange);
      }
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olf-duftfinder"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Position of each answer on the two scales (0 = fresh / energising, 1 = warm / calming).
  var POS = {
    mood: { wach: [0.16, 0.14], leicht: [0.42, 0.4], ruhig: [0.34, 0.82], warm: [0.84, 0.7] },
    room: { wohnzimmer: [0.62, 0.56], schlafzimmer: [0.62, 0.86], bad: [0.35, 0.64], kueche: [0.38, 0.22], office: [0.2, 0.24], eingang: [0.3, 0.36] }
  };
  var KEYS = ['mood', 'room', 'fam'];

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(tpl, vars) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
  }
  function reduceMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  // Scroll to an element. If smooth scrolling is blocked or interrupted, jump there instead.
  function scrollToEl(el, done) {
    var top = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - 20);
    var smooth = !reduceMotion();
    window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - top) > 40) window.scrollTo(0, top);
      if (done) done();
    }, smooth ? 900 : 0);
  }

  function init(root) {
    if (root.dataset.dfReady) return;
    root.dataset.dfReady = '1';
    var data;
    try { data = JSON.parse(root.querySelector('[data-df-json]').textContent); } catch (e) { return; }
    var candles = data.candles || [];
    candles.forEach(function (c) { c.fams = (c.fam || '').split(' ').filter(Boolean); });
    var T = data.text || {}, U = data.ui || {}, O = data.opts || {};
    var Q = { mood: T.q_mood, room: T.q_room, fam: T.q_fam };
    var answers = {};
    var step = 0;
    var $ = function (sel) { return root.querySelector(sel); };
    var find = function (key, v) { return (O[key] || []).filter(function (o) { return o.v === v; })[0]; };

    function target() {
      var pts = ['mood', 'room'].map(function (k) { return POS[k][answers[k]]; }).filter(Boolean);
      if (!pts.length) return [0.5, 0.5];
      return [pts.reduce(function (n, p) { return n + p[0]; }, 0) / pts.length,
              pts.reduce(function (n, p) { return n + p[1]; }, 0) / pts.length];
    }
    function ranked() {
      var t = target(), fam = answers.fam;
      return candles.filter(function (c) { return c.available; }).map(function (c) {
        var d = Math.hypot(c.x - t[0], c.y - t[1]);
        if (fam && fam !== 'egal') d *= c.fams.indexOf(fam) > -1 ? 0.45 : 1.25;
        return { c: c, d: d };
      }).sort(function (a, b) { return a.d - b.d; }).map(function (r) { return r.c; });
    }

    function renderStep() {
      var key = KEYS[step];
      $('[data-step-count]').textContent = fill(U.step, { n: step + 1, total: KEYS.length });
      root.querySelectorAll('.olf-df__progress span').forEach(function (el, i) { el.classList.toggle('is-done', i <= step); });
      $('[data-question]').textContent = Q[key] || '';
      var box = $('[data-options]');
      box.innerHTML = '';
      var opts = O[key] || [];
      box.setAttribute('data-n', opts.length);
      opts.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'olf-df__opt';
        b.setAttribute('aria-pressed', answers[key] === o.v ? 'true' : 'false');
        b.innerHTML = '<strong>' + esc(o.t) + '</strong><small>' + esc(o.s) + '</small>';
        b.addEventListener('click', function () { choose(key, o.v); });
        box.appendChild(b);
      });
      $('[data-back]').hidden = step === 0;
    }

    function choose(key, v) {
      answers[key] = v;
      if (step < KEYS.length - 1) {
        step++;
        setTimeout(function () {
          renderStep();
          var first = $('[data-options] .olf-df__opt');
          if (first) first.focus({ preventScroll: true });
        }, 150);
      } else {
        renderStep();
        var r = ranked();
        if (r.length) showResult(r[0], r.slice(1, 3));
      }
    }

    function why(c) {
      var room = find('room', answers.room), mood = find('mood', answers.mood);
      if (!room) return '';
      return fill(mood ? U.why_both : U.why_room, { room: room.label, mood: mood ? mood.label : '', name: c.name });
    }

    function showResult(c, alts) {
      var res = $('[data-result]');
      var gift = $('[data-gift]');
      var notes = '';
      if (c.top) notes += '<dt>' + esc(U.top) + '</dt><dd>' + esc(c.top) + '</dd>';
      if (c.heart) notes += '<dt>' + esc(U.heart) + '</dt><dd>' + esc(c.heart) + '</dd>';
      if (c.base) notes += '<dt>' + esc(U.base) + '</dt><dd>' + esc(c.base) + '</dd>';
      var facts = (c.rooms ? esc(fill(U.rooms, { rooms: c.rooms })) + ' ' : '') + esc(T.facts || '');
      var cart = (c.available && c.variant)
        ? '<form method="post" action="' + esc(data.cartAdd) + '"><input type="hidden" name="id" value="' + esc(c.variant) + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="olf-df__textbtn">' + esc(T.cart_label) + '</button></form>'
        : '<span class="olf-df__facts">' + esc(T.sold_out_text) + '</span>';
      res.innerHTML =
        '<article class="olf-df__match">' +
          '<div class="olf-df__match-img">' + (c.img ? '<img src="' + esc(c.img) + '" alt="' + esc(c.alt) + '" width="900" height="900">' : '') + '</div>' +
          '<div>' +
            '<p class="olf-df__kicker">' + esc(T.result_kicker) + '</p>' +
            '<h2 class="olf-df__name">' + esc(c.name) + '</h2>' +
            (c.mood ? '<p class="olf-df__quote">' + esc(c.mood) + '</p>' : '') +
            '<p class="olf-df__why">' + esc(why(c)) + '</p>' +
            (notes ? '<dl class="olf-df__notes">' + notes + '</dl>' : '') +
            (facts ? '<p class="olf-df__facts">' + facts + '</p>' : '') +
            '<div class="olf-df__buy">' +
              '<a class="button" href="' + esc(c.url) + '">' + esc((T.cta_label || '') + ' ' + c.name) + '</a>' +
              '<span class="olf-df__price">' + esc(c.price) + '</span>' + cart +
            '</div>' +
            (gift && gift.innerHTML.trim() ? '<div class="olf-df__gift">' + gift.innerHTML + '</div>' : '') +
          '</div>' +
        '</article>' +
        (alts.length ? '<h3 class="olf-df__alts-head">' + esc(T.alts_heading) + '</h3><div class="olf-df__alts">' + alts.map(function (a) {
          return '<a class="olf-df__alt" href="' + esc(a.url) + '">' + (a.img ? '<img src="' + esc(a.img) + '" alt="" width="96" height="96" loading="lazy">' : '<span></span>') +
            '<span><b>' + esc(a.name) + '</b><small>' + esc(a.mood) + '</small><small>' + esc(a.price) + '</small></span></a>';
        }).join('') + '</div>' : '') +
        '<div class="olf-df__restart"><button type="button" class="olf-df__textbtn" data-restart>' + esc(U.restart) + '</button></div>';
      res.hidden = false;
      res.querySelector('[data-restart]').addEventListener('click', restart);
      setTimeout(function () {
        scrollToEl(res, function () { res.focus({ preventScroll: true }); });
      }, reduceMotion() ? 0 : 200);
    }

    function restart() {
      Object.keys(answers).forEach(function (k) { delete answers[k]; });
      step = 0;
      renderStep();
      $('[data-result]').hidden = true;
      scrollToEl(root);
    }

    $('[data-back]').addEventListener('click', function () { if (step > 0) { step--; renderStep(); } });

    // Hero links: "Duftfinder starten" goes to the quiz, "Alle Duftkerzen ansehen" to the grid.
    // Works for any #link, so a translated anchor can't break it.
    if (document.querySelector('[data-olf-df]') === root) {
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-df-start], [data-df-all], a[href="#alle-duftkerzen"]');
        if (!a || (a.getAttribute('href') || '').charAt(0) !== '#') return;
        var toGrid = !a.hasAttribute('data-df-start');
        var target = toGrid ? root.querySelector('#alle-duftkerzen') : root;
        if (!target) return;
        e.preventDefault();
        scrollToEl(target, function () {
          if (toGrid) return;
          var first = $('[data-options] .olf-df__opt');
          if (first) first.focus({ preventScroll: true });
        });
      });
    }

    // Collection filter chips
    var chipsBox = $('[data-chips]');
    if (chipsBox) {
      var cards = root.querySelectorAll('[data-grid] .olf-df__card[data-fam]');
      var chips = chipsBox.querySelectorAll('.olf-df__chip');
      var filter = function (f) {
        var shown = 0;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.f === f ? 'true' : 'false'); });
        cards.forEach(function (card) {
          var on = !f || card.dataset.fam.split(' ').indexOf(f) > -1;
          card.hidden = !on;
          if (on) shown++;
        });
        $('[data-empty]').hidden = shown > 0;
      };
      chips.forEach(function (chip) {
        var f = chip.dataset.f;
        var n = 0;
        cards.forEach(function (card) { if (!f || card.dataset.fam.split(' ').indexOf(f) > -1) n++; });
        chip.querySelector('[data-count]').textContent = n;
        chip.hidden = n === 0;
        chip.addEventListener('click', function () { filter(f); });
      });
      var reset = $('[data-reset]');
      if (reset) reset.addEventListener('click', function () { filter(''); });
      chipsBox.hidden = false;
    }

    renderStep();
  }

  function initAll() { document.querySelectorAll('[data-olf-df]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-olf-df]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olfair-hero-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('olfair-hero')) {
    customElements.define(
      'olfair-hero',
      class OlfairHero extends HTMLElement {
        connectedCallback() {
          this.checkHeadings();
          this.videos = Array.from(this.querySelectorAll('video[data-src]'));
          if (!this.videos.length) return;

          this.button = this.querySelector('[data-olf-toggle]');
          const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.userPaused = prefersReduced && this.dataset.respectReducedMotion === 'true';
          this.visible = new Set();

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.visible.add(entry.target);
                else this.visible.delete(entry.target);
                this.sync(entry.target);
              });
            },
            { threshold: 0.1 }
          );

          this.videos.forEach((video) => {
            video.addEventListener('playing', () => video.classList.add('is-playing'));
            this.observer.observe(video);
          });

          if (this.button) {
            this.button.addEventListener('click', () => {
              this.userPaused = !this.userPaused;
              this.videos.forEach((video) => this.sync(video));
              this.updateButton();
            });
          }
          this.updateButton();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        sync(video) {
          if (this.visible.has(video) && !this.userPaused) {
            if (!video.getAttribute('src')) {
              const isMobile = window.matchMedia('(max-width: 749px)').matches;
              video.src = (isMobile && video.dataset.srcMobile) || video.dataset.src;
            }
            const promise = video.play();
            if (promise) promise.catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        }

        updateButton() {
          if (!this.button) return;
          this.button.setAttribute('aria-pressed', String(this.userPaused));
          const label = this.button.querySelector('[data-olf-toggle-label]');
          if (label) {
            label.textContent = this.userPaused ? this.button.dataset.labelPlay : this.button.dataset.labelPause;
          }
        }

        checkHeadings() {
          const warning = this.querySelector('[data-olf-seo-check]');
          if (!warning) return;
          const run = () => {
            const count = document.querySelectorAll('h1').length;
            warning.querySelector('[data-olf-h1-count]').textContent = count;
            warning.hidden = count === 1;
          };
          requestAnimationFrame(run);
          ['shopify:section:load', 'shopify:section:unload', 'shopify:block:select'].forEach((evt) =>
            document.addEventListener(evt, () => setTimeout(run, 50))
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
